import { fork, call, put, take, all, takeLatest } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes/header';
import config from 'config';
import apiClient from '../helpers/apiClient';

let _client = null;
function* getResource(resource, successAction, errorAction) {
  try {
    const data = yield call(async () => _client.get(resource));
    successAction.data = data;
    yield put(successAction);
  } catch (er) {
    errorAction.error = er;
    yield put(errorAction);
  }
}

function* getMainNav() {
  yield take(actionTypes.LOAD);
  yield call(
    getResource,
    config.apiPath.mainNavigation,
    { type: actionTypes.LOAD_NAVIGATION },
    { type: actionTypes.FAIL_NAVIGATION }
  );
}

function* getMobileNavigationData() {
  yield take(actionTypes.GET_MSITE_NAV);
  yield call(
    getResource,
    config.apiPath.mobileNavigationJsonUrl,
    { type: actionTypes.GET_MSITE_NAV_SUCCESS },
    { type: actionTypes.GET_MSITE_NAV_FAIL }
  );
}

function* getSearchData({ value }) {
  const successAction = { type: actionTypes.SEARCH_DATA_SUCCESS };
  // const failAction = { type: actionTypes.SEARCH_DATA_FAIL };
  const client = { ..._client };
  client.setHeader();
  const { url } = config.searchBarConfig;
  const query = value.trim();
  if (query.length > 0) {
    const requestUrl = `${url}${query}`;
    const result = yield call(async () => client.get(requestUrl));
    successAction.data = result.result;
    yield put(successAction);
  }
}

export function* runHeaderCalls(client) {
  _client = client ? Object.assign({}, client) : apiClient();
  yield all([
    fork(getMainNav),
    fork(getMobileNavigationData),
    takeLatest(actionTypes.SEARCH_INPUT_CHANGE, getSearchData),
  ]);
}
